export default __webpack_public_path__ + "static/media/Knife_1.9a92ba6d.png";